import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../../environments/environment";
import { GlobleDataShearService } from '../services';
import { finalize } from 'rxjs/operators';


@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  private totalRequests = 0;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private dataShear: GlobleDataShearService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const authToken = this.cookieService.get("_PTBA");

    // ✅ Request start
    this.totalRequests++;
    this.dataShear.datas.next({ loader: true });

    if (authToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {},
        (error) => {
          this.handleError(error);
        }
      ),
      finalize(() => {
        // ✅ Request complete
        this.totalRequests--;

        if (this.totalRequests === 0) {
          this.dataShear.datas.next({ loader: false });
        }
      })
    );
  }

  private handleError(error: any) {

    if (error.status === 401) {
      localStorage.clear();
      window.location.href = environment.accountUrl;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/application/core/auth-interceptor.service.ts